import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
//import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { applicationUrls } from 'src/app/shared/application-constants/application-urls.const';
import { ErrorHandler, HttpErrorHandler } from 'src/app/shared/services/http-error-handler.service';
import { ServerResponse } from '../../../shared/models/dto/server-response.dto';
import { PaymentType } from '../../payment/models/payment_type.model';
import { SearchPaymentInfo } from '../../payment/models/searchPaymetnInfo.model';
import { PaymentTransactionService } from './payment-transaction.service';
import { PaymentHistorySearch } from '../models/payment-history-search';

@Injectable()
export class PaymentStorageService {
  private handleError: ErrorHandler;
  constructor(
    private httpClient: HttpClient,
    private paymentTransactionService: PaymentTransactionService,
    private httpErrorHandler: HttpErrorHandler,
    // private notification: NzNotificationService
  ) {
    this.handleError =
      this.httpErrorHandler.createErrorHandler('Freelancer Service');
  }

  searchPaymentInfo(SearchPaymentInfo: SearchPaymentInfo): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(applicationUrls.payment.paymentSearchList, SearchPaymentInfo)
      .pipe(
        tap((response) => {
          if (response.data) {
            console.log("response.data->", response.data);
            this.paymentTransactionService.setPaymentMains(
              response.data
            );
          }
        })
      );
  }

  searchExcelPaymentUserInfo(SearchPaymentInfo: SearchPaymentInfo): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(applicationUrls.payment.paymentExcelSearch, SearchPaymentInfo)
      .pipe(
        tap((response) => {
          if (response.data) {
            console.log("response.data->", response.data);
            this.paymentTransactionService.setPaymentMains(
              response.data
            );
          }
        })
      );
  }

  readPaymentTypes(): Observable<PaymentType[]> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.paymentType.readPaymentType}`)
      .pipe(
        // catchError(this.handleError('Read TamOccupation', [])),
        map((serverResponse: ServerResponse) => {
          return serverResponse.data;
        }),
        tap((paymentTypes: PaymentType[]) => {
          this.paymentTransactionService.setPaymentTypes(
            paymentTypes
          );
        })
      );
  }

  readPaymentHistory(
      paymentHistorySearch: PaymentHistorySearch
    ): Observable<ServerResponse> {
      return this.httpClient.post<ServerResponse>(
        `${applicationUrls.payment.getStpPaymentHistory}`,
        paymentHistorySearch
      );
    }

  paymentReceipt(
    trnxId: any,trnxType: any): Observable<ServerResponse> {
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.jasper.paymentReceipt}/${trnxId}/${trnxType}`)
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }

  readPaymentResponse(payload: any): Observable<ServerResponse> {
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.payment.validatePayment}`,
      payload
    );
  }

  managePayment(managePayload: any): Observable<ServerResponse> {
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.payment.managePayment}`,
      managePayload
    );
  }

  manageCourseOrStpPayment(managePayload: any): Observable<ServerResponse> {
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.payment.manageCourseOrStpPayment}`,
      managePayload
    );
  }
}
